// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ion-padding {
  padding: 12px;
}

.ion-margin {
  margin: 12px;
}

app-modal-info {
  height: 100vh;
  position: relative;
}

swiper-container {
  width: 100% !important;
  height: 100% !important;
  background-color: var(--background-default);
}

swiper-slide {
  width: 100% !important;
}

.image-wrapper {
  width: 100%;
  position: relative;
  border-bottom: 0.6px solid rgba(102, 102, 102, 0.5019607843);
}
.image-wrapper ion-img {
  aspect-ratio: 373/257;
  border-radius: 2px;
  overflow: hidden;
  object-fit: contain;
}
.image-wrapper .default-img {
  background-color: #fff;
  padding: 15px;
}
.image-wrapper .info-product-icon {
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 6px;
}
.image-wrapper .img-info {
  position: absolute;
  bottom: -16px;
  right: 3%;
  font-family: AppFont;
  font-size: 11px;
  color: var(--ion-color-danger);
}
@media (max-width: 992px) {
  .image-wrapper .img-info {
    font-size: 9px;
  }
}

.slide-col {
  top: 0;
  bottom: 80px;
  position: absolute;
  display: flex;
  flex-direction: column;
  background-size: 100% 30vh !important;
  padding-bottom: 120px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.option-group-col {
  flex-shrink: 1;
  flex-basis: auto;
  margin-top: 10px;
  padding: 0 11px;
}

.grow {
  flex-grow: 1;
  overflow: auto;
}

.back-btn {
  cursor: pointer;
  position: absolute;
  margin: 0;
  font-size: 40px;
  top: 10px;
  left: 10px;
  z-index: 1;
}

ion-toolbar {
  --ion-toolbar-color: white;
  --ion-toolbar-background: var(--ion-color-primary);
}
ion-toolbar ion-icon {
  height: 36px;
  width: 36px;
  padding: 8px;
}

.menge {
  margin-inline: 16px;
  padding: 16px 0 !important;
  border-top: var(--outline-default);
  border-bottom: var(--outline-default);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.menge .quantity {
  font-family: AppFontMedium;
  font-size: 18px;
  line-height: 120%;
  letter-spacing: 0.04em;
  vertical-align: middle;
  text-transform: capitalize;
  color: var(--color-black);
}

.info {
  text-align: left;
  padding: 24px 16px !important;
}
.info .title {
  font-family: AppFontMedium;
  font-size: 26px;
  line-height: 20px;
  letter-spacing: 0;
  vertical-align: middle;
  text-transform: uppercase;
  color: var(--color-black);
  margin: 0px 0px 12px;
}
.info .desc {
  font-family: AppFont;
  font-size: 14px;
  line-height: 124%;
  letter-spacing: 0;
  color: #656564;
  margin-top: 12px;
}
.info .measurement {
  font-size: 12px;
  line-height: 110%;
  margin-top: 10px;
  margin-bottom: 10px;
}

.title > span {
  display: inline-flex;
  align-items: center;
}

.option-group-description {
  margin: 20px 16px 0;
  color: #05121A;
  font-family: AppFontMedium;
  font-size: 20px;
  letter-spacing: -0.01em;
  text-transform: uppercase;
  line-height: 100%;
  text-align: left;
}

.first-page-header {
  background: red;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  width: 100%;
}
.first-page-header ion-icon {
  zoom: 1.7;
  margin: 0px 5px;
  width: 8%;
}
.first-page-header ion-title {
  text-align: left;
}

.button-price {
  margin-left: 10px;
}

.header-block {
  display: flex;
  flex-direction: column;
  align-items: start;
}
.header-block ion-icon {
  zoom: 0.6;
}

app-tag {
  margin-top: 7px;
}

ion-item {
  border-radius: 5px;
  margin-top: 10px;
  border: 0.5px solid #e2dcd5;
}

.footer-container {
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  height: 80px;
  width: 100%;
  z-index: 999;
  background: linear-gradient(176.99deg, rgba(255, 255, 255, 0.45) -165.76%, rgba(255, 255, 255, 0.45) 97.51%);
  backdrop-filter: blur(4px);
  padding: 16px;
  box-shadow: 2px 0px 5px 0px rgba(0, 0, 0, 0.2509803922);
}

.footer-button {
  width: 100%;
  height: 54px;
  margin: 0;
}

app-universal-page-toolbar {
  --title-width: 192px;
  box-shadow: none !important;
}

.error-message {
  font-size: 12px;
  margin: 0;
  margin-left: 16px;
  margin-top: 6px;
  text-align: start;
  color: var(--ion-color-danger);
}

ion-button {
  min-height: 54px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/modal-info/modal-info.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAKA;EACC,aAAA;AAJD;;AAOA;EACC,YAAA;AAJD;;AAOA;EACC,aAAA;EACA,kBAAA;AAJD;;AAOA;EACC,sBAAA;EACA,uBAAA;EACA,2CAAA;AAJD;;AAOA;EACC,sBAAA;AAJD;;AAOA;EACC,WAAA;EACA,kBAAA;EACA,4DAAA;AAJD;AAKC;EACC,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAHF;AAMC;EACC,sBAAA;EACA,aAAA;AAJF;AAOC;EACC,eAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AALF;AAQC;EACC,kBAAA;EACA,aAAA;EACA,SAAA;EAEA,oBAAA;EACA,eAAA;EACA,8BAAA;AAPF;AC5CE;ED4CD;IAUE,cAAA;EAND;AACF;;AAUA;EACC,MAAA;EACA,YAjEe;EAkEf,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,qBAAA;EACA,cAAA;EACA,iCAAA;AAPD;;AAUA;EACC,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAPD;;AAUA;EACC,YAAA;EACA,cAAA;AAPD;;AAUA;EACC,eAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AAPD;;AAUA;EACC,0BAAA;EACA,kDAAA;AAPD;AASC;EACC,YAAA;EACA,WAAA;EACA,YAAA;AAPF;;AAWA;EACC,mBA9GgB;EA+GhB,0BAAA;EACA,kCAAA;EACA,qCAAA;EAEA,aAAA;EACA,8BAAA;EACA,mBAAA;AATD;AAWC;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,sBAAA;EACA,0BAAA;EAEA,yBAAA;AAVF;;AAcA;EACC,gBAAA;EACA,6BAAA;AAXD;AAaC;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,yBAAA;EACA,oBAAA;AAZF;AAeC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EAEA,gBAAA;AAdF;AAiBC;EACC,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AAfF;;AAmBA;EACC,oBAAA;EACA,mBAAA;AAhBD;;AAmBA;EACC,mBAAA;EACA,cAAA;EACA,0BAAA;EACA,eAAA;EACA,uBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;AAhBD;;AAmBA;EACC,eAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AAhBD;AAiBC;EACC,SAAA;EACA,eAAA;EACA,SAAA;AAfF;AAiBC;EACC,gBAAA;AAfF;;AAkBA;EACC,iBAAA;AAfD;;AAiBA;EACC,aAAA;EACA,sBAAA;EACA,kBAAA;AAdD;AAeC;EACC,SAAA;AAbF;;AAgBA;EACC,eAAA;AAbD;;AAeA;EACC,kBAAA;EACA,gBAAA;EACA,2BAAA;AAZD;;AAeA;EACC,eAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,YA9Ne;EA+Nf,WAAA;EACA,YAAA;EACA,4GAAA;EACA,0BAAA;EACA,aAAA;EACA,uDAAA;AAZD;;AAeA;EACC,WAAA;EACA,YAAA;EACA,SAAA;AAZD;;AAeA;EACC,oBAAA;EACA,2BAAA;AAZD;;AAeA;EACC,eAAA;EACA,SAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,8BAAA;AAZD;;AAeA;EACC,gBAAA;AAZD","sourcesContent":["@use '../../../theme/mixins' as *;\n\n$padding-inline: 16px;\n$footer-height: 80px;\n\n.ion-padding {\n\tpadding: 12px;\n}\n\n.ion-margin {\n\tmargin: 12px;\n}\n\napp-modal-info {\n\theight: 100vh;\n\tposition: relative;\n}\n\nswiper-container {\n\twidth: 100% !important;\n\theight: 100% !important;\n\tbackground-color: var(--background-default);\n}\n\nswiper-slide {\n\twidth: 100% !important;\n}\n\n.image-wrapper {\n\twidth: 100%;\n\tposition: relative;\n\tborder-bottom: 0.6px solid #66666680;\n\tion-img {\n\t\taspect-ratio: 373 / 257;\n\t\tborder-radius: 2px;\n\t\toverflow: hidden;\n\t\tobject-fit: contain;\n\t}\n\n\t.default-img {\n\t\tbackground-color: #fff;\n\t\tpadding: 15px;\n\t}\n\n\t.info-product-icon {\n\t\tcursor: pointer;\n\t\tposition: absolute;\n\t\ttop: 5px;\n\t\tright: 6px;\n\t}\n\n\t.img-info {\n\t\tposition: absolute;\n\t\tbottom: -16px;\n\t\tright: 3%;\n\n\t\tfont-family: AppFont;\n\t\tfont-size: 11px;\n\t\tcolor: var(--ion-color-danger);\n\n\t\t@include mobile {\n\t\t\tfont-size: 9px;\n\t\t}\n\t}\n}\n\n.slide-col {\n\ttop: 0;\n\tbottom: $footer-height;\n\tposition: absolute;\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground-size: 100% 30vh !important;\n\tpadding-bottom: 120px;\n\toverflow: auto;\n\t-webkit-overflow-scrolling: touch;\n}\n\n.option-group-col {\n\tflex-shrink: 1;\n\tflex-basis: auto;\n\tmargin-top: 10px;\n\tpadding: 0 ($padding-inline - 5px);\n}\n\n.grow {\n\tflex-grow: 1;\n\toverflow: auto;\n}\n\n.back-btn {\n\tcursor: pointer;\n\tposition: absolute;\n\tmargin: 0;\n\tfont-size: 40px;\n\ttop: 10px;\n\tleft: 10px;\n\tz-index: 1;\n}\n\nion-toolbar {\n\t--ion-toolbar-color: white;\n\t--ion-toolbar-background: var(--ion-color-primary);\n\n\tion-icon {\n\t\theight: 36px;\n\t\twidth: 36px;\n\t\tpadding: 8px;\n\t}\n}\n\n.menge {\n\tmargin-inline: $padding-inline;\n\tpadding: 16px 0 !important;\n\tborder-top: var(--outline-default);\n\tborder-bottom: var(--outline-default);\n\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\n\t.quantity {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 18px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0.04em;\n\t\tvertical-align: middle;\n\t\ttext-transform: capitalize;\n\n\t\tcolor: var(--color-black);\n\t}\n}\n\n.info {\n\ttext-align: left;\n\tpadding: 24px $padding-inline !important;\n\n\t.title {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 26px;\n\t\tline-height: 20px;\n\t\tletter-spacing: 0;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\n\t\tcolor: var(--color-black);\n\t\tmargin: 0px 0px 12px;\n\t}\n\n\t.desc {\n\t\tfont-family: AppFont;\n\t\tfont-size: 14px;\n\t\tline-height: 124%;\n\t\tletter-spacing: 0;\n\t\tcolor: #656564;\n\n\t\tmargin-top: 12px;\n\t}\n\n\t.measurement {\n\t\tfont-size: 12px;\n\t\tline-height: 110%;\n\t\tmargin-top: 10px;\n\t\tmargin-bottom: 10px;\n\t}\n}\n\n.title > span {\n\tdisplay: inline-flex;\n\talign-items: center;\n}\n\n.option-group-description {\n\tmargin: 20px $padding-inline 0;\n\tcolor: #05121A;\n\tfont-family: AppFontMedium;\n\tfont-size: 20px;\n\tletter-spacing: -0.01em;\n\ttext-transform: uppercase;\n\tline-height: 100%;\n\ttext-align: left;\n}\n\n.first-page-header {\n\tbackground: red;\n\theight: 60px;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tcolor: white;\n\twidth: 100%;\n\tion-icon {\n\t\tzoom: 1.7;\n\t\tmargin: 0px 5px;\n\t\twidth: 8%;\n\t}\n\tion-title {\n\t\ttext-align: left;\n\t}\n}\n.button-price {\n\tmargin-left: 10px;\n}\n.header-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: start;\n\tion-icon {\n\t\tzoom: 0.6;\n\t}\n}\napp-tag {\n\tmargin-top: 7px;\n}\nion-item {\n\tborder-radius: 5px;\n\tmargin-top: 10px;\n\tborder: 0.5px solid #e2dcd5;\n}\n\n.footer-container {\n\tposition: fixed;\n\tbottom: 0px;\n\tleft: 0px;\n\tright: 0px;\n\theight: $footer-height;\n\twidth: 100%;\n\tz-index: 999;\n\tbackground: linear-gradient(176.99deg, rgba(255, 255, 255, 0.45) -165.76%, rgba(255, 255, 255, 0.45) 97.51%);\n\tbackdrop-filter: blur(4px);\n\tpadding: 16px;\n\tbox-shadow: 2px 0px 5px 0px #00000040;\n}\n\n.footer-button {\n\twidth: 100%;\n\theight: 54px;\n\tmargin: 0;\n}\n\napp-universal-page-toolbar {\n\t--title-width: 192px;\n\tbox-shadow: none !important;\n}\n\n.error-message {\n\tfont-size: 12px;\n\tmargin: 0;\n\tmargin-left: 16px;\n\tmargin-top: 6px;\n\ttext-align: start;\n\tcolor: var(--ion-color-danger);\n}\n\nion-button {\n\tmin-height: 54px;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
